<template>
  <section class="contact-section" id="contact">
    <div class="contact-container">
      <div class="section-header">
        <h2 class="section-title">联系我们</h2>
        <div class="title-underline"></div>
      </div>
    <div class="contact-list">
      <!-- 卡片1：办公地点 -->
      <div class="contact-card contact-info-area">
        <div class="card-title">办公地点</div>
        <div class="info-item"><strong>办公地址：</strong>武汉市经济技术开发区葛洲坝紫郡阑园 7-1213</div>
        <div class="info-item"><strong>大修基地：</strong>武汉市蔡甸区联东 U 谷一区 4 号厂房 3 号门</div>
        <div class="info-item"><strong>邮编：</strong>430205</div>
        <div class="info-item"><strong>电话：</strong><a class="link" href="tel:15927220112">15927220112</a></div>
        <div class="info-item"><strong>邮箱：</strong><a class="link" href="mailto:jiangxinzc02@163.com">jiangxinzc02@163.com</a></div>
      </div>

      <!-- 卡片2：留言表单 -->
      <form class="contact-card contact-form-area" @submit.prevent="handleSubmit">
        <!-- 姓名（必填） -->
        <div class="form-field">
          <div class="input-wrapper">
            <span class="required-star">*</span>
            <input type="name" v-model="formData.name" placeholder="您的姓名" required
            :class="{ 'error-input': errors.name }" @input="clearFieldError('name')"/>
          </div>
          <div v-if="errors.name" class="field-error">{{ errors.name }}</div>
        </div>
        <!-- 电话（必填） -->
        <div class="form-field">
          <div class="input-wrapper">
            <span class="required-star">*</span>
            <input type="tel" v-model="formData.tel" placeholder="您的电话" required 
              :class="{ 'error-input': errors.tel }" @input="clearFieldError('tel')"/>
          </div>
          <div v-if="errors.tel" class="field-error">{{ errors.tel }}</div>
        </div>
        <!-- 邮箱（非必填） -->
        <div class="form-field">
          <div class="input-wrapper">
            <input type="email" v-model="formData.email" placeholder="您的邮箱（选填）" 
              :class="{ 'error-input': errors.email }" @input="clearFieldError('email')"/>
          </div>
          <div v-if="errors.email" class="field-error">{{ errors.email }}</div>
        </div>
        <!-- 留言内容（必填） -->
        <div class="form-field">
          <div class="input-wrapper">
            <span class="required-star">*</span>
            <textarea v-model="formData.content" placeholder="留言内容" required
              :class="{ 'error-input': errors.content }" @input="clearFieldError('content')">
            </textarea>
          </div>
          <div v-if="errors.content" class="field-error">{{ errors.content }}</div>
        </div>
        
        <button type="submit" :disabled="isSubmitting" class="submit-btn"
          :class="{
            'btn-submitting': isSubmitting,
            'btn-success': buttonText === '提交成功 ✓',
            'btn-error': buttonText === '提交失败 ✗'}">
          {{ buttonText }}
        </button>
      </form>
    </div>
    </div>
  </section>
</template>

<script>
import { sendNotification } from '@/api/contact';

export default {
  name: 'ContactForm',
  data() {
    return {
      formData: {
        name: '',
        tel: '',
        email: '',
        content: ''
      },
      errors: {
        name: '',
        tel: '',
        email: '',
        content: ''
      },
      isSubmitting: false,
      buttonText: '提交留言'
    };
  },
  methods: {
    // 清除单个字段的错误
    clearFieldError(field) {
      if (this.errors[field]) {
        this.errors[field] = '';
      }
    },

    // 清除所有错误
    clearAllErrors() {
      this.errors = {
        name: '',
        tel: '',
        email: '',
        content: ''
      };
    },

    // 表单验证
    validateForm() {
      this.clearAllErrors();
      let isValid = true;
      
      // 姓名验证
      if (!this.formData.name.trim()) {
        this.errors.name = '姓名不能为空';
        isValid = false;
      }
      
      // 电话验证（必填，且为11位数字）
      const phoneRegex = /^1[3-9]\d{9}$/;
      if (!this.formData.tel.trim()) {
        this.errors.tel = '电话不能为空';
        isValid = false;
      } else if (!phoneRegex.test(this.formData.tel)) {
        this.errors.tel = '请输入有效的11位手机号码';
        isValid = false;
      }
      
      // 邮箱验证（如果填写了）
      if (this.formData.email.trim()) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(this.formData.email)) {
          this.errors.email = '请输入有效的邮箱地址';
          isValid = false;
        }
      }
      
      // 留言内容验证
      if (!this.formData.content.trim()) {
        this.errors.content = '留言内容不能为空';
        isValid = false;
      }
      
      return isValid;
    },

    // 更新按钮状态
    updateButtonState(text, duration = 3000) {
      this.buttonText = text;
      
      // 如果是成功或失败状态，2秒后不仅恢复文字，还要恢复颜色
      if (duration > 0) {
        setTimeout(() => {
          this.buttonText = '提交留言';
          // 不需要手动移除类，因为类名绑定会自动根据buttonText更新
        }, duration);
      }
    },

    async handleSubmit() {
      // 先进行表单验证
      if (!this.validateForm()) {
        // 滚动到第一个错误字段
        const firstError = document.querySelector('.field-error');
        if (firstError) {
          firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return;
      }

      this.isSubmitting = true;
      this.updateButtonState('提交中...', 0); // 立即改变按钮文字，不自动恢复

      try {
        // 调用后端API
        const response = await sendNotification(this.formData);

        if (response.data.success) {
          this.updateButtonState('提交成功 ✓', 3000);
          this.resetForm();
        } else {
          this.updateButtonState('提交失败 ✗', 3000);
          console.error('提交失败：', response.data.message);
        }
      } catch (error) {
        this.updateButtonState('提交失败 ✗', 3000);
        console.error('提交出错：', error);
      } finally {
        this.isSubmitting = false;
      }
    },

    resetForm() {
      this.formData = {
        name: '',
        tel: '',
        email: '',
        content: ''
      };
      this.clearAllErrors();
    }
  }
};
</script>

<style scoped>
/* section container */
.contact-section {
  background: #f5f7fa;
  padding: 80px 0;
}

.contact-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

.section-header {
  margin-bottom: 26px;
}

.section-title {
  font-size: 2rem;
  font-weight: 800;
  color: #1a1a2e;
  margin-bottom: 12px;
  letter-spacing: 1px;
}

.title-underline {
  width: 60px;
  height: 3px;
  background: #1976d2;
  border-radius: 2px;
}

/* 容器样式 */
.contact-list {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 18px;
  width: 100%;
  margin: 20px 0 0 0;
}

/* 卡片公共样式 */
.contact-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 32px 24px 20px 24px;
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 420px;
  box-sizing: border-box;
  border: 1px solid #eef2f7;
}

/* 卡片1：办公地点 */
.contact-info-area {
  align-items: flex-start;
}

.card-title {
  font-size: 1.4rem;
  color: #1976d2;
  margin-bottom: 24px;
  font-weight: bold;
  width: 100%;
  text-align: center;
  border-bottom: 2px solid #e3f2fd;
  padding-bottom: 12px;
}

.info-item {
  font-size: 1.1rem;
  color: #444;
  margin-bottom: 16px;
  line-height: 1.5;
}

.link {
  color: #1976d2;
  text-decoration: none;
}

.link:hover {
  text-decoration: underline;
}

/* 卡片2：留言表单 */
.contact-form-area {
  width: 100%;
}
/* 表单字段容器 */
.form-field {
  width: 100%;
  margin-bottom: 20px;
  position: relative;
}
/* 输入框包装器，用于相对定位红星 */
.input-wrapper {
  position: relative;
  width: 100%;
}
/* 红星样式（标记必填） */
.required-star {
  position: absolute;
  left: -12px;
  top: 3px;
  color: #ff4d4f;
  font-size: 16px;
  font-weight: bold;
}

/* 输入框样式 */
.contact-form-area input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #cfd8dc;
  border-radius: 6px;
  font-size: 1rem;
  box-sizing: border-box;
  font-family: inherit;
  transition: border-color 0.2s, box-shadow 0.2s;
  height: 38px;
  display: block; /* 确保块级显示 */
}

/* 文本框样式 */
.contact-form-area textarea {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #cfd8dc;
  border-radius: 6px;
  font-size: 1rem;
  box-sizing: border-box;
  font-family: inherit;
  transition: border-color 0.2s, box-shadow 0.2s;
  min-height: 80px;
  max-height: 110px;
  resize: vertical;
  display: block; /* 确保块级显示 */
}

/* 输入框焦点效果 */
.contact-form-area input:focus,
.contact-form-area textarea:focus {
  outline: none;
  border-color: #1976d2;
  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.1);
}

/* 输入框错误样式 */
.error-input {
  border-color: #ff4d4f !important;
}

.error-input:focus {
  box-shadow: 0 0 0 3px rgba(255, 77, 79, 0.1) !important;
}

/* 字段错误提示 - 使用绝对定位悬浮在间距空间中 */
.field-error {
  color: #ff4d4f;
  font-size: 0.8rem;
  left: 0;
  text-align: left;
  line-height: 1.2;
  position: absolute;
  bottom: -18px; /* 定位在输入框下方，20px间距内 */
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  pointer-events: none; /* 防止错误信息阻挡点击 */
}

/* 当没有错误信息时，完全隐藏 */
.field-error:empty {
  display: none;
}

/* 提交按钮基础样式 */
.submit-btn {
  background: #1976d2;
  color: #fff;
  border: none;
  border-radius: 6px;
  width: 90%;
  font-size: 1.2rem;
  cursor: pointer;
  transition: all 0.5s ease; /* 改为all，让所有属性都有过渡效果 */
  font-weight: bold;
  height: 40px;
  position: relative;
  overflow: hidden;
}

/* 按钮悬停效果 */
.submit-btn:hover:not(:disabled):not(.btn-success):not(.btn-error) {
  background: #125ea7;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(25, 118, 210, 0.3);
}

/* 提交中状态 */
.submit-btn.btn-submitting {
  background: #5c6bc0;
  cursor: wait;
  opacity: 0.9;
}

/* 提交中状态的悬停效果 */
.submit-btn.btn-submitting:hover {
  background: #3f51b5;
  transform: none;
  box-shadow: none;
}

/* 成功状态 - 绿色 */
.submit-btn.btn-success {
  background: #4caf50;
  cursor: default;
}

.submit-btn.btn-success:hover {
  background: #43a047;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(76, 175, 80, 0.3);
}

/* 失败状态 - 红色 */
.submit-btn.btn-error {
  background: #f44336;
  cursor: default;
}

.submit-btn.btn-error:hover {
  background: #e53935;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(244, 67, 54, 0.3);
}

/* 按钮禁用状态 */
.submit-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

/* 添加波纹效果（可选，增加交互感） */
.submit-btn::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 5px;
  height: 5px;
  background: rgba(255, 255, 255, 0.5);
  opacity: 0;
  border-radius: 100%;
  transform: scale(1, 1) translate(-50%);
  transform-origin: 50% 50%;
}

@keyframes ripple {
  0% {
    transform: scale(0, 0);
    opacity: 1;
  }
  20% {
    transform: scale(25, 25);
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: scale(40, 40);
  }
}

.submit-btn:focus:not(:active)::after {
  animation: ripple 1s ease-out;
}

@media (max-width: 900px) {
  .contact-section {
    padding: 56px 0;
  }
  .contact-list {
    grid-template-columns: 1fr;
  }
}
</style>